module.exports = __webpack_public_path__ + "static/media/icon_postgresql.0ee9607c.svg";